import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Wallpaper from "@/pages/Wallpaper";
import { initNative } from "@/lib/native";

function App() {
  useEffect(() => {
    initNative();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Wallpaper />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#F5F3ED",
            color: "#2C2A28",
            border: "1px solid #E5E1D8",
            fontFamily: "Fraunces, 'Iowan Old Style', Georgia, serif",
          },
        }}
      />
    </div>
  );
}

export default App;
